import { Pipe, type PipeTransform } from '@angular/core';

/** «4 000 ₽» — whole rubles, no-break space between thousands and before the sign; a negative sum reads «−4 000 ₽» (U+2212). */
export function formatMoney(value: number): string {
  return new Intl.NumberFormat('ru-RU', { style: 'currency', currency: 'RUB', maximumFractionDigits: 0 })
    .format(value)
    .replace('-', '−');
}

@Pipe({ name: 'money' })
export class MoneyPipe implements PipeTransform {
  transform(value: number): string {
    return formatMoney(value);
  }
}
